import { NgModule } from '@angular/core';
import { MaterialModule } from '../shared';

import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth.routing.module';

import { LoginComponent } from './components/login/login.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ProfileComponent } from './components/profile/profile.component';
import { GuestLoginComponent } from './components/guest-login/guest-login.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { DeactivateComponent } from './components/deactivate/deactivate.component';
import { OtpLoginComponent } from './components/otp-login/otp-login.component';

@NgModule({
  imports: [AuthRoutingModule, MaterialModule, SharedModule],
  declarations: [
    LoginComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    ProfileComponent,
    GuestLoginComponent,
    SignUpComponent,
    DeactivateComponent,
    OtpLoginComponent,
  ],
  exports: [],
  entryComponents: [],
})
export class AuthModule {}
